export default {
  en: {
    termsOfPayment: 'Terms of Payment',
    newTermsOfPayment: 'New Terms of Payment',
    name: 'Name',
    description: 'Description',
    status: 'Status',
    createTermsOfPayment: 'Create Terms of Payment',
    cancel: 'Cancel',
    addSuccessTitle: 'Success',
    addSuccessMessage: 'Create Terms of Payment Success'
  },
  th: {
    termsOfPayment: 'เงื่อนไขการชำระเงิน',
    newTermsOfPayment: 'สร้างเงื่อนไขการชำระเงิน',
    name: 'หัวข้อ',
    description: 'รายละเอียด',
    status: 'สถานะ',
    createTermsOfPayment: 'สร้างเงื่อนไขการชำระเงิน',
    cancel: 'ยกเลิก',
    addSuccessTitle: 'สำเร็จ',
    addSuccessMessage: 'สร้างเงื่อนไขการชำระเงินสำเร็จ'
  }
}
